<template>
 <v-card class="pa-1" style="min-height:800px">
    <v-card-title style="background:#F4F7FC;letter-spacing: .5px;;color: #1A2453;font-size: 12px;" class="py-2 subheading text-uppercase">
        <!-- <v-icon small class="grey--text">fas fa-filter</v-icon> &nbsp; -->
       <b> Filters</b>
    </v-card-title>
    <v-card-text class="pa-0 ma-0">
        <v-layout row wrap class="text-xs-left">
            <template v-for="(filter,key) in value">
                <v-flex xs12 sm12 pa-2>  
                    <DropDown v-if="filter.type=='select' || filter.dataSet" 
                    :filters="filter"
                    @change="(value) => {setFilterValues(filter,value)}"
                    />
                   <DropDownReport2  :selected ="filter.default" v-if="filter.type=='sel3ect' || filter.dataSet" 
                    :filters="filter"
                    outlineBorder="true"
                    multipleOptions="true"
                    :needChip="true"
                    @input="(value) => {filter.default=value}"
                    v-on:change="setFilterId"
                    />
                    <TextFilter  outlineBorder="true" :filters="filter" v-if="filter.type=='text' && filter.id !=='show_intransit'  " 
                         @change="(value) => {setFilterValues(filter,value)}"
      
                    />
                        <TextFilter  outlineBorder="true" :filters="filter" v-if="filter.type=='text' && filter.id =='show_intransit' && company==='nextgen'" 
                         @change="(value) => {setFilterValues(filter,value)}"
      
                    />
                    
                    <TextFilter  outlineBorder="true" :filters="filter" v-if="filter.type=='date'" 
                         @change="(value) => {setFilterValues(filter,value)}"
                   
                    />
                    <!-- <DateFilter :selected ="filter.default"  :filters="filter" v-if="filter.type=='date'" 
                        v-on:selectedDates="setFilterId"
                    /> -->
                </v-flex>
            </template>
        </v-layout>
    </v-card-text>
</v-card>     
</template>
<script>
import DropDownReport2 from '@/components/DropDownReport2.vue'
import ReportModel from '../../service/ReportService';
import DropDown from '../reports/DropDown.vue'
import TextFilter from '../reports/TextFilter.vue'
import ReportSubscriptionModel from '../../service/ReportSubscriptionService';  
  export default {
      props:["value"],
      components: {
          DropDown,
          TextFilter,
          DropDownReport2
      },
    data () {
      return {
          filtersData:{},
          company:''
      }
    },
       watch: {
    value() {
        this.filtersData={}
      this.filtersData = this.value;
    }
  },
    created: function() {
      this.filtersData={}
      this.filtersData = this.value;
      this.company = localStorage.getItem('CLIENT_ID')

    },
    mounted: function(){
      
    },
    methods: {
        setFilterId(selected) {
          var $keys = Object.keys(selected);

         /// this.filters[$keys[0]].default=selected[$keys[0]]
         
        },
        setFilterValues($filter,$values) {
          //this.value[$filter.id]=$filter
          $filter.default = $values[$filter.id]
          this.$forceUpdate()
        //  this.filter.default = $values[$filter.id]
        },
        setDetails($data){
     
        },
    }
  }
</script>